import { request } from '@/common/services/request';

const scopedRequest = async (path, organizationId, config) => {
  if (!organizationId) {
    throw new Error('缺少组织');
  }
  const result = await request(`/api/harness${path}`, {
    params: { organizationId },
    ...config,
  });
  return result.data;
};

export const getHarnessInstance = ({ organizationId }) =>
  scopedRequest('/instance', organizationId, { method: 'GET' });

export const startHarnessInstance = ({ organizationId }) =>
  scopedRequest('/instance', organizationId, { method: 'POST' });

export const getHarnessVersions = ({ organizationId, next }) =>
  scopedRequest('/versions', organizationId, {
    method: 'GET',
    params: { organizationId, next },
  });

export const getHarnessOrganization = ({ organizationId }) =>
  scopedRequest('/organization', organizationId, { method: 'GET' });

export const upgradeHarnessOrganization = ({ organizationId, tag, retry }) =>
  scopedRequest('/upgrade', organizationId, {
    method: 'POST',
    data: retry === true ? { retry: true } : { tag },
  });
